module.exports = __webpack_public_path__ + "c6a06c4fc9fb1f10446c1173c57cb21a.svg";